import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_2 = { class: "p-5" }
const _hoisted_3 = { class: "form-floating mb-3" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-floating mb-3" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = { class: "d-flex w-100" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = {
  key: 0,
  class: "img-container"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "d-flex w-100" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = {
  key: 1,
  class: "img-container"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "d-flex w-100" }
const _hoisted_17 = { class: "form-floating flex-fill me-2" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-floating" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  class: "d-flex w-100 mb-3 mt-3",
  role: "group",
  "aria-label": "Basic radio toggle button group"
}
const _hoisted_22 = ["checked"]
const _hoisted_23 = ["checked"]
const _hoisted_24 = ["checked"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { class: "form-floating mb-2" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "d-flex w-100 mb-2" }
const _hoisted_30 = { class: "form-floating flex-fill me-2" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "form-floating flex-fill" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "d-flex w-100 mb-2" }
const _hoisted_35 = { class: "form-floating flex-fill me-2" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "form-floating flex-fill" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "d-flex w-100" }
const _hoisted_40 = { class: "form-floating flex-fill me-2" }
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "form-floating flex-fill" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { key: 4 }
const _hoisted_45 = { class: "form-floating" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "d-flex w-100 gap-2" }
const _hoisted_48 = { class: "form-floating w-50" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "form-floating w-50" }
const _hoisted_51 = ["value"]
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "form-floating flex-fill mb-2" }
const _hoisted_54 = { class: "form-floating flex-fill" }
const _hoisted_55 = { class: "d-flex align-items-center" }
const _hoisted_56 = { class: "w-100 d-flex align-items-center" }
const _hoisted_57 = {
  key: 5,
  class: "d-flex w-100 mt-3"
}
const _hoisted_58 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarkdownEditor = _resolveComponent("MarkdownEditor")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_payment_option_modal = _resolveComponent("payment-option-modal")!
  const _component_ticket_payment_options = _resolveComponent("ticket-payment-options")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex border-bottom align-items-center px-3", _ctx.editing ? 'bg-secondary text-white' : ''])
    }, [
      _createElementVNode("h5", {
        class: _normalizeClass(["border-0", _ctx.editing ? 'text-start' : 'text-center w-100'])
      }, [
        _cache[25] || (_cache[25] = _createTextVNode(" Modificar evento: ", -1)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.event.title), 1)
      ], 2),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              class: "btn btn-outline-light ms-auto",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args)))
            }, " Reestablecer "),
            _createElementVNode("button", {
              class: "btn btn-primary ms-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args)))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Guardar cambios")
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          ref: "title",
          type: "text",
          class: "form-control",
          placeholder: "Nombre del evento",
          onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          value: _ctx.currentData?.title || _ctx.eventData?.title,
          name: "title",
          autocomplete: "false"
        }, null, 40, _hoisted_4),
        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Nombre", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "Organizador del evento",
          onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          value: _ctx.currentData?.organizer || _ctx.eventData?.organizer,
          name: "organizer",
          autocomplete: "false"
        }, null, 40, _hoisted_6),
        _cache[27] || (_cache[27] = _createElementVNode("label", null, "Organizador", -1))
      ]),
      _cache[49] || (_cache[49] = _createElementVNode("h5", null, "Detalles del evento", -1)),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.eventLoading)
          ? (_openBlock(), _createBlock(_component_MarkdownEditor, {
              key: 0,
              "initial-value": _ctx.eventData?.details,
              "onUpdate:modelValue": _ctx.modifyDescription,
              id: "edit-event-description"
            }, null, 8, ["initial-value", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _cache[50] || (_cache[50] = _createElementVNode("h5", null, "Imagen de portada", -1)),
      _cache[51] || (_cache[51] = _createElementVNode("p", null, " La imagen que utilices debe tener 1100 x 300 px para una correcta visualización. ", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("input", {
            ref: "image",
            type: "file",
            class: "form-control",
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fileSelected && _ctx.fileSelected(...args))),
            accept: "image/*"
          }, null, 544)
        ])
      ]),
      (_ctx.currentData?.image || _ctx.eventData?.image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("img", {
              src: 
        typeof (_ctx.currentData?.image || _ctx.eventData?.image) == 'object'
          ? ((_ctx.currentData?.image || _ctx.eventData?.image) as any).src
          : _ctx.currentData?.image || _ctx.image
      ,
              class: "w-100 cover"
            }, null, 8, _hoisted_11),
            _createElementVNode("button", {
              class: "btn btn-danger",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteCover && _ctx.deleteCover(...args)))
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("i", { class: "fas fa-trash" }, null, -1),
              _createTextVNode(" Eliminar portada ", -1)
            ]))])
          ]))
        : _createCommentVNode("", true),
      _cache[52] || (_cache[52] = _createElementVNode("h5", null, "Logotipo", -1)),
      _cache[53] || (_cache[53] = _createElementVNode("p", null, [
        _createTextVNode(" Esta imagen se mostrará en el ticket. Para una correcta visualización esta imagen debe tener "),
        _createElementVNode("strong", null, "200 x 75 px"),
        _createTextVNode(" y en formato "),
        _createElementVNode("strong", null, "png"),
        _createTextVNode(". ")
      ], -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("input", {
            ref: "logo",
            type: "file",
            class: "form-control",
            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args))),
            accept: "image/png"
          }, null, 544)
        ])
      ]),
      (_ctx.currentData?.logo || _ctx.eventData?.logo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("img", {
              src: 
        typeof (_ctx.currentData?.logo || _ctx.eventData?.logo) == 'object'
          ? ((_ctx.currentData?.logo || _ctx.eventData?.logo) as any).src
          : _ctx.currentData?.logo || _ctx.logo
      ,
              class: "logo-img"
            }, null, 8, _hoisted_15),
            _createElementVNode("button", {
              class: "btn btn-danger",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.deleteLogo && _ctx.deleteLogo(...args)))
            }, [...(_cache[29] || (_cache[29] = [
              _createElementVNode("i", { class: "fas fa-trash" }, null, -1),
              _createTextVNode(" Eliminar logo ", -1)
            ]))])
          ]))
        : _createCommentVNode("", true),
      _cache[54] || (_cache[54] = _createElementVNode("h5", null, "Información de contacto", -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("input", {
            ref: "email",
            type: "email",
            class: "form-control",
            placeholder: "Email",
            autocomplete: "false",
            onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
            value: _ctx.currentData?.email ?? _ctx.eventData?.email,
            name: "email"
          }, null, 40, _hoisted_18),
          _cache[30] || (_cache[30] = _createElementVNode("label", null, "Email", -1))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Teléfono",
            autocomplete: "false",
            onKeyup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
            value: _ctx.currentData?.phone || _ctx.eventData?.phone,
            name: "phone"
          }, null, 40, _hoisted_20),
          _cache[31] || (_cache[31] = _createElementVNode("label", null, "Teléfono", -1))
        ])
      ]),
      _cache[55] || (_cache[55] = _createElementVNode("h5", null, "Ubicación", -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("input", {
          type: "radio",
          class: "btn-check",
          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          checked: 
          (_ctx.currentData?.location_type || _ctx.eventData?.location_type) == 'place'
        ,
          name: "location_type",
          value: "place",
          id: "location_type_event-place",
          autocomplete: "off"
        }, null, 40, _hoisted_22),
        _cache[32] || (_cache[32] = _createElementVNode("label", {
          class: "flex-fill btn btn-outline-secondary me-2",
          for: "location_type_event-place"
        }, " Lugar ", -1)),
        _createElementVNode("input", {
          type: "radio",
          class: "btn-check",
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          checked: 
          (_ctx.currentData?.location_type || _ctx.eventData?.location_type) == 'on-line'
        ,
          name: "location_type",
          value: "on-line",
          id: "location_type_event-on-line",
          autocomplete: "off"
        }, null, 40, _hoisted_23),
        _cache[33] || (_cache[33] = _createElementVNode("label", {
          class: "flex-fill btn btn-outline-secondary me-2",
          for: "location_type_event-on-line"
        }, " En linea ", -1)),
        _createElementVNode("input", {
          type: "radio",
          class: "btn-check",
          onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          checked: 
          (_ctx.currentData?.location_type || _ctx.eventData?.location_type) ==
          'to-be-announced'
        ,
          name: "location_type",
          value: "to-be-announced",
          id: "location_type_event-to-be-announced",
          autocomplete: "off"
        }, null, 40, _hoisted_24),
        _cache[34] || (_cache[34] = _createElementVNode("label", {
          class: "flex-fill btn btn-outline-secondary",
          for: "location_type_event-to-be-announced"
        }, "Por anunciar", -1))
      ]),
      (
        (_ctx.currentData?.location_type || _ctx.eventData?.location_type) !=
        'to-be-announced'
      )
        ? (_openBlock(), _createElementBlock("hr", _hoisted_25))
        : _createCommentVNode("", true),
      ((_ctx.currentData?.location_type || _ctx.eventData?.location_type) == 'place')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("input", {
                text: "email",
                class: "form-control",
                placeholder: "Nombre",
                autocomplete: "false",
                onKeyup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                value: _ctx.currentData?.addr_name || _ctx.eventData?.addr_name,
                name: "addr_name"
              }, null, 40, _hoisted_28),
              _cache[35] || (_cache[35] = _createElementVNode("label", null, "Nombre", -1))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Calle y número",
                  autocomplete: "false",
                  onKeyup: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                  value: _ctx.currentData?.addr_address_1 || _ctx.eventData?.addr_address_1,
                  name: "addr_address_1"
                }, null, 40, _hoisted_31),
                _cache[36] || (_cache[36] = _createElementVNode("label", null, "Calle y número", -1))
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Colonia o distrito",
                  autocomplete: "false",
                  onKeyup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                  value: _ctx.currentData?.addr_address_2 || _ctx.eventData?.addr_address_2,
                  name: "addr_address_2"
                }, null, 40, _hoisted_33),
                _cache[37] || (_cache[37] = _createElementVNode("label", null, "Colonia o distrito", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Ciudad",
                  autocomplete: "false",
                  onKeyup: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                  value: _ctx.currentData?.addr_city || _ctx.eventData?.addr_city,
                  name: "addr_city"
                }, null, 40, _hoisted_36),
                _cache[38] || (_cache[38] = _createElementVNode("label", null, "Ciudad", -1))
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Estado",
                  autocomplete: "false",
                  onKeyup: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                  value: _ctx.currentData?.addr_state || _ctx.eventData?.addr_state,
                  name: "addr_state"
                }, null, 40, _hoisted_38),
                _cache[39] || (_cache[39] = _createElementVNode("label", null, "Estado", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Pais",
                  autocomplete: "false",
                  onKeyup: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                  value: _ctx.currentData?.addr_country || _ctx.eventData?.addr_country,
                  name: "addr_country"
                }, null, 40, _hoisted_41),
                _cache[40] || (_cache[40] = _createElementVNode("label", null, "Pais", -1))
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Código Postal",
                  autocomplete: "false",
                  onKeyup: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                  value: _ctx.currentData?.addr_zip || _ctx.eventData?.addr_zip,
                  name: "addr_zip"
                }, null, 40, _hoisted_43),
                _cache[41] || (_cache[41] = _createElementVNode("label", null, "Código Postal", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (
        (_ctx.currentData?.location_type || _ctx.eventData?.location_type) == 'on-line'
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "URL del evento",
                autocomplete: "false",
                onKeyup: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                value: _ctx.currentData?.online_url || _ctx.eventData?.online_url,
                name: "online_url"
              }, null, 40, _hoisted_46),
              _cache[42] || (_cache[42] = _createElementVNode("label", null, "URL del evento (HTTPS)", -1))
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[56] || (_cache[56] = _createElementVNode("h5", null, "Pagos", -1)),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("select", {
            class: "form-control",
            name: "accept_bitcoin",
            value: _ctx.currentData.accept_bitcoin || _ctx.eventData.accept_bitcoin,
            onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args)))
          }, [...(_cache[43] || (_cache[43] = [
            _createElementVNode("option", { value: "accept_bitcoin" }, "Sí", -1),
            _createElementVNode("option", { value: "not_accept_bitcoin" }, "No", -1)
          ]))], 40, _hoisted_49),
          _cache[44] || (_cache[44] = _createElementVNode("label", null, "Aceptar Bitcoin (BTC)", -1))
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("select", {
            class: "form-control",
            name: "currency",
            value: _ctx.currentData.currency || _ctx.eventData.currency || '',
            onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.currencies), ([id, val]) => {
              return (_openBlock(), _createElementBlock("option", {
                key: id,
                value: id
              }, _toDisplayString(val), 9, _hoisted_52))
            }), 128))
          ], 40, _hoisted_51),
          _cache[45] || (_cache[45] = _createElementVNode("label", null, "Divisa", -1))
        ])
      ]),
      _cache[57] || (_cache[57] = _createElementVNode("h5", null, "Fecha y hora", -1)),
      _createElementVNode("div", _hoisted_53, [
        _createVNode(_component_VueDatePicker, {
          "onUpdate:modelValue": _ctx.modifyDateStart,
          "model-value": _ctx.currentData?.eventDateStart || _ctx.eventData?.eventDateStart,
          name: "eventDateStart",
          vertical: "",
          "enable-time-picker": true,
          "is-24": false,
          "time-picker-inline": "",
          class: "form-control p-0 w-100",
          "min-date": new Date(),
          format: _ctx.formatDate
        }, null, 8, ["onUpdate:modelValue", "model-value", "min-date", "format"]),
        _cache[46] || (_cache[46] = _createElementVNode("label", null, "Fecha y hora de inicio", -1))
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_component_VueDatePicker, {
          "onUpdate:modelValue": _ctx.modifyDateEnd,
          "model-value": _ctx.currentData?.eventDateEnd || _ctx.eventData?.eventDateEnd,
          name: "eventDateEnd",
          vertical: "",
          "enable-time-picker": true,
          "is-24": false,
          "time-picker-inline": "",
          class: "form-control p-0",
          "min-date": new Date(),
          format: _ctx.formatDate
        }, null, 8, ["onUpdate:modelValue", "model-value", "min-date", "format"]),
        _cache[47] || (_cache[47] = _createElementVNode("label", null, "Fecha y hora de final", -1))
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("h5", _hoisted_56, [
          _cache[48] || (_cache[48] = _createTextVNode(" Opciones de pago por comission ", -1)),
          _createVNode(_component_payment_option_modal, {
            "button-class": "ms-auto d-flex align-items-center",
            "event-id": _ctx.event.id
          }, null, 8, ["event-id"])
        ])
      ]),
      _createVNode(_component_ticket_payment_options, {
        "payment-options": _ctx.paymentOptions,
        "event-id": _ctx.eventId,
        onRemovePaymentOption: _ctx.removePaymentOption
      }, null, 8, ["payment-options", "event-id", "onRemovePaymentOption"]),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("button", {
              class: "btn btn-secondary ms-auto",
              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args)))
            }, " Reestablecer "),
            _createElementVNode("button", {
              class: "btn btn-primary ms-2",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args)))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Guardar cambios")
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_58))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}